module.exports = __webpack_public_path__ + "img/a12.f23e9eb6.png";